import { useState, useEffect } from "react";
import { getSavedFilters } from "../../http/api";

export const useSavedFilters = (token) => {
  const [savedFilters, setSavedFilters] = useState([]);

  useEffect(() => {
    const fetchSavedFilters = async () => {
      try {
        const filters = await getSavedFilters(token);
        setSavedFilters(filters);
      } catch (error) {
        console.error("Error fetching saved filters:", error);
      }
    };
    fetchSavedFilters();
  }, [token]);

  return { savedFilters, setSavedFilters };
};